import { render, staticRenderFns } from "./EditStamm.vue?vue&type=template&id=4857b90f&scoped=true"
import script from "./EditStamm.vue?vue&type=script&lang=ts"
export * from "./EditStamm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857b90f",
  null
  
)

export default component.exports